module.exports = __webpack_public_path__ + "img/00005.e50caf47.webp";